import './trips.css';
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";

import {tripSummary} from "../../data/driversData";
import {useEffect, useState} from "react";
import TripsCard from "../../components/tripsComponent/tripsCards/tripsCards";
import AllTrips from "../../components/tripsComponent/allTrips/allTrips";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import {format} from "date-fns";
import TripService from "../../services/trip.service";
import tripService from "../../services/trip.service";
import Loaders from "../../shared/loaders/loaders";

const Trips = () => {
    const [summary, setSummary] = useState(tripSummary);
    const [startDate, setStartDate] = useState(new Date(2023, 9, 18));
    const [endDate, setEndDate] = useState(new Date());
    const [trips, setTrips] = useState([]);
    // const [tripsCounts, setTripsCounts] = useState({});
    const [tripsPages, setTripsPages] = useState({});
    const [showLoader, setShowLoader] = useState(false);

    const startDateFormatted = format(new Date(startDate), 'yyyy-MM-dd');
    const endDateFormatted = format(new Date(endDate), 'yyyy-MM-dd');

    const handleDateChange = (date) => {
        if (date[1]) {
            setStartDate(date[0]);
            setEndDate(date[1]);
        }
    }

    // ...... get trips .......
    const getTrips = async (pageNumber) => {
        const tripsData = await TripService.getTrips(startDateFormatted, endDateFormatted, pageNumber);
        if (!tripsData?.message) {
            setTrips(tripsData?.trips);
            setTripsPages(tripsData?.meta);
        } else {

        }
    }

    // ..... get trip counts .......
    const getTripCounts = async () => {
        const tripsCount = await TripService.getTripCounts(startDateFormatted, endDateFormatted);
        if (!tripsCount?.message) {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    counts: tripsCount
                }
            })
        } else {

        }
    }

    // ...... get alerts ........
    const getAlerts = async () => {
        const alerts = await tripService.getTripAlerts(startDateFormatted, endDateFormatted);
        if (!alerts?.message) {
            setSummary((prevState) => {
                return {
                    ...prevState,
                    alerts: alerts
                }
            })
        } else {

        }
    }

    const onPageChange = async (page) => {
        setShowLoader(true);
        await getTrips(page);
        setShowLoader(false);
    }


    useEffect(() => {
        (async () => {
                setShowLoader(true);
                await getTrips(1);
                await getTripCounts();
                await getAlerts();
                setShowLoader(false);
            }

        )()

    }, [endDate]);


    return (
        <div className={'page-fade-in'}>
            <div className={'content-section'}>
                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        selectRange={true}
                        onDateChange={handleDateChange}
                        classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*..... card dashboard .....*/}
                <div className="margin-b-50"><TripsCard/></div>

                {/*..... overall summary .....*/}
                {/*<div className="margin-b-50"><OverallSummary/></div>*/}
            </div>
            <div className={'margin-b-30'}>
                <div className={'content-section'}>
                    {/*..... drivers overall summary .....*/}
                    <div className=" border-bottom padding-b-20"><DriversSummary summary={summary}/></div>
                </div>
            </div>

            <div className="">
                <div className={'content-section'}>
                    {/*..... All trips .....*/}
                    <div className=""><AllTrips trips={trips}
                                                pagination={tripsPages}
                                                onPageChange={onPageChange}/></div>
                </div>
            </div>

            {showLoader &&
                <div className="loader-box blue-loader">
                    <Loaders/>
                </div>
            }
        </div>
    )
}

export default Trips;
